// 役割定義
export const USER_ROLES = {
  SUPER_ADMIN: '0',  // スーパー管理者
  ADMIN: '1',        // 管理者
  DEPT_MANAGER: '2', // 部門長
  USER: '3'          // 担当
};

// メニュー権限マッピング
export const MENU_PERMISSIONS = {
  '/F001': ['0', '1', '2', '3'],     // 受注明細 - 全員
  '/G001': ['0', '1', '2', '3'],     // 発注明細 - 全員
  '/H001': ['0', '1', '2'],          // 発注管理 - 管理者以上
  '/Q001': ['0', '1', '2', '3'],     // 見積管理 - 全員
  '/J001': ['0', '1', '2'],          // 仕入管理 - 管理者以上
  '/K001': ['0', '1', '2', '3'],     // 在庫管理 - 全員
  '/M001': ['0', '1', '2'],          // 振分管理 - 管理者以上
  '/M011': ['0', '1', '2'],          // 分納管理 - 管理者以上
  '/O001': ['0', '1', '2', '3'],     // 出庫管理 - 全員
  '/O002': ['0', '1', '2'],          // 出庫承認 - 管理者以上
  '/R001': ['0', '1', '2'],          // 業務成績管理 - 管理者以上
  '/E001': ['0', '1'],               // 商品管理 - 管理者のみ
  '/S001': ['0', '1', '2', '3'],     // 会社管理 - 全員
  '/C001': ['0', '1'],               // 担当者管理 - 管理者のみ
  '/S00101': ['0', '1'],             // 事務所管理 - 管理者のみ
  '/C00101': ['0', '1'],             // 社員管理 - 管理者のみ
  '/B001': ['0', '1'],               // 部署管理 - 管理者のみ
  '/D003': ['0'],                    // マスタインポート - スーパー管理者のみ
  '/PCA01': ['0', '1'],              // PCAエクスポート - 管理者のみ
  '/D001-dashboard': ['0', '1', '2', '3'], // ダッシュボード - 全員
  '/A001': ['0', '1', '2'],          // 承認一覧 - 管理者以上
  '/A002': ['0', '1', '2'],          // 承認履歴 - 管理者以上
  '/A003': ['0', '1'],               // 承認フロー設定 - 管理者のみ
  '/P001': ['0', '1', '2'],          // 引当計画管理 - 管理者以上
  '/P002': ['0', '1', '2']           // 引当計画詳細 - 管理者以上
};

// 権限チェック関数
export function hasMenuPermission(menuUrl, userRole) {
  const allowedRoles = MENU_PERMISSIONS[menuUrl];
  if (!allowedRoles) return true; // 未設定の場合は表示
  return allowedRoles.includes(userRole);
}

// ユーザーの表示可能メニューリストを取得
export function getVisibleMenus(menus, userRole) {
  return menus.filter(menu => hasMenuPermission(menu.url, userRole));
}



// WEBPACK FOOTER //
// ./src/config/menuPermissions.js